import React from "react";
import "./About.css";
import { Helmet } from "react-helmet-async";

const About = () => {
    return (
        <>
       <Helmet>
    <title>About PRT Academy | IT Training Institute in Hyderabad</title>

    <meta
        name="description"
        content="Learn about PRT Academy, an IT training institute in Hyderabad offering industry-focused courses, practical training, internships, and placement assistance."
    />

    <meta
        name="keywords"
        content="About PRT Academy,PRT Academy Hyderabad,
PRT Academy IT Training Institute,
Industry-focused IT Training in Hyderabad,
PRT Academy Placement Assistance,
Practical Training,
Live Projects,
Internships,
Placement Assistance,
Career Guidance"
    />
</Helmet>

            <section className="inner-page about-page">

                <div className="page-badge">
                    About PRT Academy
                </div>

                <h1>
                    Learn. Build. <span>Grow.</span>
                </h1>

                <p className="page-intro">
                    PRT Academy helps students and aspiring developers build
                    practical software development skills through structured
                    training, real-time projects and placement preparation.
                </p>

                <div className="about-grid">

                    <div className="about-card">
                        <h2>Our Mission</h2>
                        <p>
                            Our mission is to help learners become confident
                            software developers by combining strong technical
                            foundations with practical project experience.
                        </p>
                    </div>

                    <div className="about-card">
                        <h2>Our Approach</h2>
                        <p>
                            We focus on hands-on learning, real-world projects,
                            mentor guidance, coding practice and placement
                            preparation.
                        </p>
                    </div>

                    <div className="about-card">
                        <h2>Industry Experience</h2>
                        <p>
                            Students get exposure to development workflows,
                            Git, GitHub, Jira, APIs, responsive interfaces
                            and real project practices.
                        </p>
                    </div>

                </div>

            </section>

            
        </>
    );
};

export default About;